import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaEnvelope, FaBriefcase, FaArrowRight } from 'react-icons/fa';
import html2pdf from 'html2pdf.js';
// --- DATA (Projects remain as they are company-wide) ---
const projects = [
    {
      title: 'MASRIQ NextTech Solutions',
      description: 'Leading digital transformation, AI, and cloud solutions for global clients.',
      image: '/assets/Masriq_Logo.png',
      link: 'https://masriq.tech',
    },
    {
      title: 'EventMate-AI',
      description: 'AI-powered event management platform for seamless guest handling, smart scheduling, and analytics.',
      image: '/assets/EventMateLogo.jpg',
      link: 'https://eventmate-ai.com',
    },
    
    {
      title: 'Poll-in Platform',
      description: 'Real-time polls, quizzes, and interactive chat for community engagement.',
      image: '/assets/pollin_logo.png',
      link: '#',
    },
    {
      title: 'Guesversity Tours & Travels',
      description: 'Affordable Cab & Airport Taxi Services in Bangalore',
      image: '/assets/GUESTVERSITY-PNG.png',
      link: 'https://gttravels.in/',
    },
    {
      title: 'Prasanna Tours & Travels',
      description: 'Your go-to source for reliable travel solutions, whether for weddings, corporate events, or family trips.',
      image: '/assets/ptt.png',
      link: 'https://prasannatravel.com/',
    },
  ];

// --- UPDATED SKILLS FOR RIYA TANWAR ---
const skills = [
  'Full Stack Development',
  'Frontend UI/UX',
  'Backend Scalability',
  'High-Performance Solutions',
  'Creative Design',
  'Digital Solutions',
];

// --- ROADMAP DATA (Company Milestones) ---
const timelineEvents = [
    { year: '2025', event: 'Full Stack Developer at MASRIQ NextTech Solutions.' },
    { year: '2025', event: 'Bachelor of Technology in Computer Engineering (AIML Specialization).' },
    { year: '2024', event: 'Front End Developer Intern at AXM (ArtistxMusic).' },
    { year: '2021', event: '[12th GRADE] at Sumermal Jain Public School,New Delhi' },
    { year: '2019', event: '[10th GRADE] at Sumermal Jain Public School,New Delhi' },
];


const RiyaPortfolio = () => {
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);

    // Animation variants for staggering children
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.6 }
        },
    };

    // PDF generator
    const handleGeneratePDF = () => {
        const element = document.getElementById('portfolio-content');
        const style = document.createElement('style');
        style.innerHTML = `
          #portfolio-content, #portfolio-content * {
            background: #181824 !important;
            color: #fff !important;
            font-family: 'Inter', 'Arial', sans-serif !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        `;
        document.head.appendChild(style);
        html2pdf()
          .set({
            margin: 0,
            filename: 'Riya_Portfolio.pdf',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2, backgroundColor: '#181824', useCORS: true },
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['css', 'legacy'] },
          })
          .from(element)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            const blob = pdf.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            setPdfPreviewUrl(blobUrl);
            document.head.removeChild(style);
          });
    };

    return (
        <motion.div
            className="portfolio-container bg-gradient-to-br from-[#181824] via-[#23243a] to-[#1a1a2e] min-h-[100dvh] text-white px-2 py-8 sm:px-4 sm:py-10 flex items-center justify-center pt-12 sm:pt-16 overflow-y-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            {/* Download Button */}
            <button
                className="absolute top-6 right-6 z-50 bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-bold py-2 px-4 rounded-full shadow-lg hover:scale-105 hover:shadow-xl transition-all duration-300 flex items-center gap-2"
                onClick={handleGeneratePDF}
                aria-label="Download Portfolio as PDF"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-8m0 8l-4-4m4 4l4-4M4 20h16" />
                </svg>
                Download PDF
            </button>
            <div
                id="portfolio-content"
                style={{ background: '#181824', color: '#fff', minHeight: '100vh', fontFamily: 'Inter, Arial, sans-serif' }}
                className="w-full max-w-3xl mx-auto rounded-3xl shadow-2xl backdrop-blur-lg p-4 sm:p-8 relative mt-4 sm:mt-16 mb-8 sm:mb-16"
            >
                {/* --- HEADER SECTION --- */}
                <motion.div variants={containerVariants} initial="hidden" animate="visible" className="text-center">
                    <motion.div variants={itemVariants} className="relative inline-block mb-6">
                        <div className="absolute -inset-1 rounded-full bg-gradient-to-tr from-cyan-400 to-purple-600 blur-sm animate-pulse"></div>
                        <motion.img
                            src="/team/Riya_img.webp"
                            alt="Ms. Riya Tanwar, Full Stack Developer"
                            className="relative w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-full mx-auto border-4 border-[#23243a] shadow-lg object-cover"
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300 }}
                        />
                    </motion.div>
                    
                    <motion.h1 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-cyan-300 to-purple-400 mb-2">
                        Riya Tanwar
                    </motion.h1>
                    
                    <motion.h2 variants={itemVariants} className="text-md sm:text-lg md:text-xl text-purple-300 mb-4 font-semibold tracking-wide">
                        Full Stack Developer, MASRIQ NextTech Solutions
                    </motion.h2>
                    
                    <motion.p variants={itemVariants} className="max-w-2xl mx-auto text-sm sm:text-base text-white/80 mb-8">
                      Full stack developer Riya Tanwar focuses on frontend UI/UX and backend scalability. Her creativity and coding expertise help MASRIQ deliver user-friendly, high-performance digital solutions.
                    </motion.p>

                    <motion.div variants={itemVariants} className="flex justify-center gap-5 sm:gap-6 mb-12">
                         <a href="https://www.linkedin.com/in/riyatanwar/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Profile" className="text-2xl text-white/70 hover:text-cyan-400 transition-all duration-300 hover:scale-110 hover:drop-shadow-[0_0_8px_rgba(45,212,191,0.7)]">
                            <FaLinkedin />
                        </a>
                        <a href="https://github.com/RiyaTanwar15" target="_blank" rel="noopener noreferrer" aria-label="GitHub Profile" className="text-2xl text-white/70 hover:text-cyan-400 transition-all duration-300 hover:scale-110 hover:drop-shadow-[0_0_8px_rgba(45,212,191,0.7)]">
                            <FaGithub />
                        </a>
                        <a href="mailto:riya.masriqnxttech@gmail.com" aria-label="Email" className="text-2xl text-white/70 hover:text-cyan-400 transition-all duration-300 hover:scale-110 hover:drop-shadow-[0_0_8px_rgba(45,212,191,0.7)]">
                            <FaEnvelope />
                        </a>
                        <span className="text-2xl text-cyan-400 scale-110 drop-shadow-[0_0_8px_rgba(45,212,191,0.7)]">
                            <FaBriefcase />
                        </span>
                    </motion.div>
                </motion.div>

                {/* --- SKILLS SECTION --- */}
                <motion.div
                    className="portfolio-section mb-12"
                    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
                >
                    <h3 className="text-xl sm:text-2xl font-bold text-center text-cyan-300 mb-6">Skills & Expertise</h3>
                    <div className="flex flex-wrap gap-2 sm:gap-3 justify-center text-sm sm:text-base">
                        {skills.map(skill => (
                            <span key={skill} className="bg-white/10 text-cyan-200 px-4 py-1.5 sm:px-5 sm:py-2 rounded-full shadow-sm border border-white/10 hover:bg-white/20 hover:shadow-md hover:shadow-cyan-500/20 transition-all duration-300 cursor-default">
                                {skill}
                            </span>
                        ))}
                    </div>
                </motion.div>

                {/* --- PROJECTS SECTION --- */}
                <motion.div
                    className="portfolio-section mb-12"
                    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }}
                >
                    <h3 className="text-xl sm:text-2xl font-bold text-center text-cyan-300 mb-6">Featured Projects</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        {projects.map(project => (
                             <a key={project.title} href={project.link} target="_blank" rel="noopener noreferrer" className="group block relative">
                                <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-2xl blur opacity-0 group-hover:opacity-75 transition duration-500"></div>
                                <div className="relative bg-[#1a1a2e]/80 rounded-2xl p-6 shadow-lg h-full flex flex-col items-center text-center border border-white/10">
                                    <img src={project.image} alt={`${project.title} logo`} className="w-20 h-20 object-contain rounded-xl mb-4 border-2 border-cyan-400/30" />
                                    <h4 className="text-lg sm:text-xl font-bold text-cyan-200 mb-2">{project.title}</h4>
                                    <p className="text-sm text-white/80 flex-grow">{project.description}</p>
                                    <div className="mt-4 text-sm sm:text-base text-cyan-400 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        View Project <FaArrowRight className="transform group-hover:translate-x-1 transition-transform" />
                                    </div>
                                </div>
                             </a>
                        ))}
                    </div>
                </motion.div>
                
                {/* --- TIMELINE SECTION --- */}
                <motion.div
                    className="portfolio-section mb-12"
                    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.4 }}
                >
                    <h3 className="text-xl sm:text-2xl font-bold text-center text-cyan-300 mb-8">Roadmap & Milestones</h3>
                    <div className="relative max-w-2xl mx-auto">
                        {/* The vertical line */}
                        <div className="absolute left-3 sm:left-4 top-0 h-full w-0.5 bg-cyan-200/20"></div>
                        
                        {timelineEvents.map((item, index) => (
                            <motion.div 
                                key={index} 
                                className="relative pl-10 sm:pl-12 mb-8"
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                            >
                                {/* The dot */}
                                <div className="absolute left-3 sm:left-4 top-1 w-4 h-4 bg-gradient-to-r from-cyan-400 to-purple-500 rounded-full -translate-x-1/2 border-4 border-[#1a1a2e]"></div>
                                <p className="font-bold text-purple-300 text-base sm:text-lg">{item.year}</p>
                                <p className="text-white/80 text-sm sm:text-base">{item.event}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* --- CONTACT SECTION --- */}
                <motion.div
                    className="portfolio-section text-center"
                    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.6 }}
                >
                    <h3 className="text-xl sm:text-2xl font-bold text-cyan-300 mb-4">Let's Create Together</h3>
                    <p className="text-white/80 mb-6 max-w-lg mx-auto text-sm sm:text-base">Passionate about clean code and creative design. For project ideas or collaborations, don't hesitate to reach out.</p>
                    <a 
                        href="mailto:riya.masriqnxttech@gmail.com" 
                        className="inline-block bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-bold py-2.5 px-6 sm:py-3 sm:px-8 rounded-full shadow-lg shadow-cyan-500/20 hover:scale-105 hover:shadow-xl hover:shadow-cyan-500/40 transition-all duration-300 text-sm sm:text-base"
                    >
                        Get in Touch
                    </a>
                </motion.div>
            </div>

            {/* PDF PREVIEW MODAL */}
            {pdfPreviewUrl && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-xl w-[90%] h-[90%] flex flex-col">
                        <iframe src={pdfPreviewUrl} className="flex-grow rounded-t-xl" title="PDF Preview" />
                        <div className="flex justify-between p-4 border-t">
                            <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setPdfPreviewUrl(null)}>
                                Cancel
                            </button>
                            <a href={pdfPreviewUrl} download="Riya_Portfolio.pdf" className="bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-4 py-2 rounded">
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </motion.div>
    );
};

export default RiyaPortfolio;